import React from "react";
import { Link, useLocation } from "react-router-dom";
import { Home, Sparkles, ShoppingBag, Radio, User } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

const TABS = [
  { to: "/", label: "Home", icon: Home, key: "home" },
  { to: "/kundali", label: "Kundali", icon: Sparkles, key: "kundali" },
  { to: "/shop", label: "Shop", icon: ShoppingBag, key: "shop" },
  { to: "/learn", label: "Learn", icon: Radio, key: "learn" },
];

export default function MobileNav() {
  const loc = useLocation();
  const { user } = useAuth();
  const authed = user && user !== false;

  const targetProfile = authed
    ? user.role === "admin" ? "/admin"
    : (user.role === "astrologer" || user.role === "pandit") ? "/provider"
    : "/dashboard"
    : "/login";

  const isActive = (to) => {
    if (to === "/") return loc.pathname === "/";
    return loc.pathname.startsWith(to);
  };

  return (
    <nav
      data-testid="mobile-bottom-nav"
      className="lg:hidden fixed bottom-0 left-0 right-0 z-40 border-t border-white/10 bg-black/90 backdrop-blur-2xl"
      style={{ paddingBottom: "env(safe-area-inset-bottom)" }}
    >
      <div className="grid grid-cols-5">
        {TABS.map((t) => {
          const Ic = t.icon;
          const active = isActive(t.to);
          return (
            <Link
              key={t.key}
              to={t.to}
              data-testid={`mobile-nav-${t.key}`}
              className={`flex flex-col items-center justify-center gap-1 py-2.5 relative transition-colors ${
                active ? "text-[#D4AF37]" : "text-[#A0A4AB]"
              }`}
            >
              {active && (
                <span className="absolute top-0 left-1/2 -translate-x-1/2 w-8 h-0.5 bg-[#D4AF37] rounded-b-full" />
              )}
              <Ic size={19} strokeWidth={active ? 2 : 1.5} />
              <span className="text-[10px] tracking-wide">{t.label}</span>
            </Link>
          );
        })}
        <Link
          to={targetProfile}
          data-testid="mobile-nav-profile"
          className={`flex flex-col items-center justify-center gap-1 py-2.5 relative transition-colors ${
            ["/dashboard","/admin","/provider"].some(p => loc.pathname.startsWith(p))
              ? "text-[#D4AF37]" : "text-[#A0A4AB]"
          }`}
        >
          {authed && user.name ? (
            <div className="w-6 h-6 rounded-full bg-[#D4AF37] text-black text-[11px] font-medium flex items-center justify-center">
              {user.name[0].toUpperCase()}
            </div>
          ) : (
            <User size={19} strokeWidth={1.5} />
          )}
          <span className="text-[10px] tracking-wide">
            {authed ? (user.role === "admin" ? "Admin" : (user.role === "astrologer" || user.role === "pandit") ? "Studio" : "Me") : "Login"}
          </span>
        </Link>
      </div>
    </nav>
  );
}
